import styled, { css } from 'styled-components';

interface IContainerProps {
  isIncrease: boolean;
  filterIsOpen: boolean;
}

export const Container = styled.div<IContainerProps>`
  width: 97%;
  display: grid;
  grid-gap: 20px;
  margin: 3.43rem 0;
  align-items: center; 
  justify-items: center;
  grid-template-rows: repeat(3, auto);
  ${({ isIncrease, filterIsOpen }) => {
    if (isIncrease && filterIsOpen) {
      return css`
        grid-template-columns: ${ isIncrease => isIncrease ? "repeat(2, 1fr)" : 'repeat(3, 1fr)'};
      `;
    }

    if (isIncrease && !filterIsOpen) {
      return css`
        grid-template-columns: ${ isIncrease => isIncrease ? "repeat(3, 1fr)" : 'repeat(4, 1fr)'};
      `;
    }

    if (!isIncrease && !filterIsOpen) {
      return css`
        grid-template-columns: repeat(4, 1fr);
      `;
    }

    if (!isIncrease && filterIsOpen) {
      return css`
        grid-template-columns: repeat(3, 1fr);
      `;
    }
  }}

  @media (max-width: 1400px) {
    grid-template-columns: ${({ isIncrease }) => isIncrease ? "repeat(2, 1fr)" : 'repeat(3, 1fr)'};
  }

  @media (max-width: 1200px) {
    grid-template-columns: ${({ isIncrease }) => isIncrease ? "repeat(1, 1fr)" : 'repeat(2, 1fr)'};
  }

  @media (max-width: 847px) {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }
`;

export const Button = styled.div`
  width: 30%;
  height: 41px;
  display: flex;
  
  border-radius: 20px;
  margin: 0 auto 2rem auto;
  padding: 8px 11px;
  justify-content: center;
  align-items: center;
  transition:  background-color 0.3s;

  &:hover{
    cursor: pointer;
    background-color:  #89E2FA;
  }

  h1 {
    color: #00C0F3;
    font-size: 19px;
    font-weight: 700;
    text-align: left;
    line-height: 25px;
    margin: 0 1rem 0 0;
  }

  @media(max-width:820px) {
    width: 97%;
  }
`;

export const ResultsWrapper = styled.div`
  width: 97%;
  display: flex;
  align-items: center;
  margin: 2.4rem 0 0 0;
  justify-content: space-between;

  @media (max-width: 820px) {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin: 2.4rem 0 -2.4rem 0;

    .results {
      p {
        margin: 1rem 0;
      }

      span {
        margin: 1rem 0 1rem .5rem !important;
      }
    }
  }
  
  .results {
    p, span {
      font-size: 26px;
      font-weight: 400;
      line-height: 120%; 
      font-style: normal;
      margin: 1rem 0 0 0;   
      color: ${({ theme }) => theme.colors.secundary};
    }
  
    span {
      font-weight: bold;
      margin: 1rem 0 0 .5rem;   
    }
  }

  .chip {
    padding: .5rem;
    span {
      font-size: 16px;
      font-weight: 400;
      line-height: 120%; 
      font-style: normal;
    }
  }
`;

export const GetAllErrorContainer = styled.div`
  width: 97%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin:9.8rem 0 44.3rem 0;
`;
